import { Spinner } from '@/components/ui/primitives';

export function PageLoader() {
  return (
    <div className="flex min-h-screen w-full items-center justify-center">
      <div className="flex flex-col items-center gap-4">
        <Spinner size="md" />
        <p className="text-sm text-text-secondary">Loading...</p>
      </div>
    </div>
  );
}
